module.exports = __webpack_public_path__ + "static/media/letter-1-min.894727ea.png";